import React, { useContext, Fragment, useEffect } from "react";
import { SegmentacaoPublicoContext } from "../SegmentacaoPublicoContext";
import Pesquisar from "../../../../../Components/Cadastro/Pesquisar/Pesquisar";
import TabelaResultados from "../../../../../Components/Cadastro/TabelaResultados/TabelaResultados";

const PesquisarSegmentacaoPublico = () => {
  const { values, setValues, resetScreen } = useContext(SegmentacaoPublicoContext);

  useEffect(() => {
    resetScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      searchData: {
        ...values.searchData,
        [name]: value,
      },
    });
  }

  return (
    <Fragment>
      <Pesquisar context={SegmentacaoPublicoContext}>
        <div className="col-12 col-md-4 form-group">
          <label>Nome da Base</label>
          <input
            className="form-control"
            type="text"
            name="segmentacaoPublicoNome"
            value={values.searchData.segmentacaoPublicoNome}
            onChange={onChangeInput}
          />
        </div>

        <div className="col-12 col-md-3 form-group">
          <label>Produto</label>
          <select
            className="form-control"
            name="produtoId"
            value={values.searchData.produtoId}
            onChange={onChangeInput}
          >
            <option className="disabled" value="0"></option>
            {values.produtos.map((produto) => (
              <option key={produto.produtoId} value={produto.produtoId}>
                {produto.produtoNome}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-md-3 form-group">
          <label>Status</label>
          <select
            className="form-control"
            name="segmentacaoPublicoStatus"
            value={values.searchData.segmentacaoPublicoStatus}
            onChange={onChangeInput}
          >
            <option className="disabled" value=""></option>
            {values.statusList.map((status) => (
              <option key={status.key} value={status.key}>
                {status.value}
              </option>
            ))}
          </select>
        </div>
      </Pesquisar>
      <TabelaResultados context={SegmentacaoPublicoContext} />
    </Fragment>
  );
};

export default PesquisarSegmentacaoPublico;
